import React from 'react';
import { AssignedMicrophone } from 'core/models/layout';
import { SettingFormGroup } from '../SettingFormGroup';
import { MicrophoneSettingForm } from '../MicrophoneSettingForm';
import { MicrophoneDevice, MediaDevice } from 'core/models/mediaDevice';

export type MicrophoneSettingFormGroupProps = {
    groupName: string;
    keyBase?: string;
    assignedMicrophones: AssignedMicrophone[];
    duplicateMicrophones: Set<MediaDevice.Tag>;
    mediaDevices: MicrophoneDevice[] | undefined;
    min?: number;
    max?: number;
    onChange: (assignedMicrophones: AssignedMicrophone[]) => void;
    getAudioConfig?: (mediaDeviceId: MediaDevice.Id) => Promise<Partial<MediaDevice.AudioConfig>>;
    putAudioConfig?: (mediaDeviceId: MediaDevice.Id, config: Partial<MediaDevice.AudioConfig>) => Promise<void>;
}

export const MicrophoneSettingFormGroup = (props: MicrophoneSettingFormGroupProps) => {
    const { keyBase = 'key', assignedMicrophones, duplicateMicrophones, mediaDevices, min, onChange, getAudioConfig, putAudioConfig } = props;

    function replace<T>(xs: T[], i: number, x: T) {
        return xs.map((y, j) => j == i ? x : y);
    }

    function remove<T>(xs: T[], i: number) {
        return xs.filter((_, j) => j != i);
    }

    return (
        <SettingFormGroup {...props} addLabel={'one more microphone...'} forms={assignedMicrophones} max={1}>
            {
                assignedMicrophones.map((current, i) =>
                    <MicrophoneSettingForm
                        key={`${keyBase}-${i}`}
                        assignedMicrophone={current}
                        duplicate={current.tag != undefined && duplicateMicrophones.has(current.tag)}
                        microphones={mediaDevices}
                        isRemovable={assignedMicrophones.length > (min ?? 0)}
                        onChange={x => onChange(replace(assignedMicrophones, i, x))}
                        onRemove={() => onChange(remove(assignedMicrophones, i))}
                        getAudioConfig={getAudioConfig}
                        putAudioConfig={putAudioConfig}
                    />)
            }
        </SettingFormGroup>
    );
};
